module.exports = "/_next/static/images/browser-is-not-supported-8d4aab1cf8ad2962feb72179d8d0fd49.svg";